import React from 'react';
import PropTypes from 'prop-types';
import { faUndo } from '@fortawesome/free-solid-svg-icons';
import { CPButton } from './styles';

export function CancelButton({ content, onClick, disabled }) {
  return (
    <CPButton
      onClick={onClick}
      disabled={disabled}
      content={content}
      icon={faUndo}
    />
  );
}

CancelButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

CancelButton.defaultProps = {
  onClick: () => null,
  content: 'Відміна',
  disabled: false,
};

export default CancelButton;
